import BookIcon from '@material-ui/icons/Book'
import ReviewShow from './ReviewShow'
import ReviewList from './ReviewList'

export default {
  list: ReviewList,
  show: ReviewShow,
  icon: BookIcon,
}
